import { yunpb } from "@/types/protobuf";
import GameStateMgr from "../GameStateMgr";
import { IStateType } from "./IGameState";
import pb from "@pb/index.json";
import Logger from "@/js/logger";
import { message } from "ant-design-vue";
import { usePlayGameStore } from "@/store/playGame";
import * as Accounts from "@js/account";
import BusinessManager from "@/js/controls";
import { checkGameWindOpen } from "../game-window";
export default class GameBaseState {
  _gameStateMgr!: GameStateMgr;
  PLAYERSTATUS = pb.nested.yunpb.nested.PlayerStatus.values;
  playGameStore;
  constructor() {
    this.playGameStore = usePlayGameStore();
    this._gameStateMgr = window.gameStateMgr;
  }
  // 设置状态
  setState(type: IStateType) {
    if (this._gameStateMgr) {
      this._gameStateMgr.setState(type);
    } else {
      Logger.error("_gameStateMgr null");
    }
  }
  async getOper(game: pro.yunpb.IGetGameRoomInfoRsp) {
    const gameInfo = game?.gameBaseInfo;
    const { areaId } = this.playGameStore.areaData;

    if (!game) return;

    Logger.log(`getOper: ${gameInfo?.gameId}`);

    const gameId = gameInfo?.gameId;
    const isOnlineGame = gameInfo?.gameId;

    if (gameId) {
      const data: pro.yunpb.ICltPlayGameReq = {
        gameId,
        accountId: Number(Accounts.getAccountId()),
      };

      isOnlineGame && areaId && (data.areaId = areaId);
      const ret: WebSocketRes<pro.yunpb.ICltPlayGameRes> =
        (await BusinessManager.PlayGame(
          data
        )) as WebSocketRes<pro.yunpb.ICltPlayGameRes>;
      Logger.log("启动游戏返回" + ret);

      if (ret && ret.code === 0) {
        if (!ret.obj) {
          Logger.log(
            `GameBaseState BusinessManager PlayGame return empty object`
          );
          this.playGameStore.resetModalState();
          return Promise.reject(null);
        }
        this.playGameStore.isQueueing = true;
        Accounts.setCurrentGame(ret.obj.gameNode!);
        return Promise.resolve(ret.obj);
      } else {
        const defaultTips = "Failed to start the game, please try again.";
        this.showToastMessage((ret.obj as any)?.desc || defaultTips);
        this.playGameStore.resetModalState();
        return Promise.reject(null);
      }
    }
  }
  // 获取状态
  getState(type: IStateType) {
    if (this._gameStateMgr) {
      this._gameStateMgr.getState(type);
    } else {
      Logger.error("_gameStateMgr null");
    }
    Logger.log("GameBaseState getState");
  }
  // 过渡到下一个状态
  playGame(game: yunpb.IGetGameRoomInfoRsp | null) {
    Logger.log("GameBaseState playGame");
  }
  showToastMessage(msg: string) {
    message.destroy();
    message.error(msg, 3);
  }
  // 退出状态
  exitGame() {
    this.playGameStore.resetModalState();
    Logger.log("GameBaseState exitGame");
  }
  //   重置
  resetState() {
    Logger.log("GameBaseState resetState");
  }
  // 页面首次加载时 第一次进入状态 FREE = 0, IN_QUE = 1, MISS_ENTER_GAME = 2, CAN_ENTER_GAME = 3, CAN_RETURN_GAME = 4,
  onPageReload() {
    Logger.log("GameBaseState onFirstState");
  }
  onStateEnter() {
    Logger.log("GameBaseState onStateEnter");
  }
  // 重新排队
  reQueueGame() {
    Logger.log("GameBaseState reQueueGame");
    // 游戏中 需要先关闭游戏窗口、退出游戏
    if (checkGameWindOpen()) {
      this.playGameStore.handleGameExit();
    }
    this.setState(IStateType.FREE);
    const game: yunpb.IGetGameRoomInfoRsp = Accounts.getSelectGame();
    this._gameStateMgr.playGame(game);
  }
}
